module.exports = __webpack_public_path__ + "img/title_3@2x.b628f008.png";